<template>
    <ReceiptEntry></ReceiptEntry>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ReceiptEntry = defineAsyncComponent(() =>
    import("../../components/Purchasing/ReceiptEntry/ReceiptEntry.vue")
);

export default {
    name: "ReceiptEntry_Purchashing",
    components: { ReceiptEntry, AuthLayout },
};
</script>
